const edgeConnectionsState = {
    edgeConnections: undefined,
    edgeOfferingConnections: undefined,
    requestingCreateEdgeConnection: false,
    requestingEdgeConnections: false,
    requestingEdgeOfferingConnections: false,
    requestingModifyEdgeConnection: false,
    requestingRemoveEdgeConnection: false
};
export default edgeConnectionsState;
